import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

/* ─── Grade schemes ───────────────────────────────────────── */
export const createGradeScheme = async (data) =>
  (await axiosInstance.post("/report-cards/grade-schemes/create", data)).data;
export const getAllGradeSchemes = async (filters = {}) =>
  (await axiosInstance.get(`/report-cards/grade-schemes/all${qs(filters)}`))
    .data;
export const getGradeSchemeById = async (id) =>
  (await axiosInstance.get(`/report-cards/grade-schemes/${id}`)).data;
export const updateGradeScheme = async (id, data) =>
  (await axiosInstance.put(`/report-cards/grade-schemes/update/${id}`, data))
    .data;
export const deleteGradeScheme = async (id) =>
  (await axiosInstance.delete(`/report-cards/grade-schemes/delete/${id}`)).data;
export const previewGrade = async (schemeId, percentage) =>
  (
    await axiosInstance.get(
      `/report-cards/grade-schemes/preview${qs({ schemeId, percentage })}`
    )
  ).data;

/* ─── Templates ───────────────────────────────────────────── */
export const createTemplate = async (data) =>
  (await axiosInstance.post("/report-cards/templates/create", data)).data;
export const getAllTemplates = async (filters = {}) =>
  (await axiosInstance.get(`/report-cards/templates/all${qs(filters)}`)).data;
export const getTemplateById = async (id) =>
  (await axiosInstance.get(`/report-cards/templates/${id}`)).data;
export const updateTemplate = async (id, data) =>
  (await axiosInstance.put(`/report-cards/templates/update/${id}`, data)).data;
export const deleteTemplate = async (id) =>
  (await axiosInstance.delete(`/report-cards/templates/delete/${id}`)).data;

/* ─── Source + batches ────────────────────────────────────── */
export const getMarksSourcePreview = async (filters = {}) =>
  (await axiosInstance.get(`/report-cards/source-preview${qs(filters)}`)).data;
export const createBatch = async (data) =>
  (await axiosInstance.post("/report-cards/batches/create", data)).data;
export const getAllBatches = async (filters = {}) =>
  (await axiosInstance.get(`/report-cards/batches/all${qs(filters)}`)).data;
export const getBatchById = async (id) =>
  (await axiosInstance.get(`/report-cards/batches/${id}`)).data;
export const generateBatch = async (id) =>
  (await axiosInstance.post(`/report-cards/batches/generate/${id}`)).data;
export const publishBatch = async (id) =>
  (await axiosInstance.post(`/report-cards/batches/publish/${id}`)).data;
export const unpublishBatch = async (id) =>
  (await axiosInstance.post(`/report-cards/batches/unpublish/${id}`)).data;
export const deleteBatch = async (id) =>
  (await axiosInstance.delete(`/report-cards/batches/delete/${id}`)).data;

/* ─── Cards ───────────────────────────────────────────────── */
export const getReportCardById = async (id) =>
  (await axiosInstance.get(`/report-cards/cards/${id}`)).data;
export const updateReportCardRemarks = async (id, data) =>
  (await axiosInstance.put(`/report-cards/cards/remarks/${id}`, data)).data;
export const getReportCardPrintPayload = async (id) =>
  (await axiosInstance.get(`/report-cards/cards/${id}/print`)).data;

/** HTML view URL (new tab / iframe) */
export const getReportCardHtmlUrl = (id) =>
  `${API}/report-cards/cards/${id}/html`;

/** Direct PDF URL (optional) */
export const getReportCardPdfUrl = (id) =>
  `${API}/report-cards/cards/${id}/pdf`;

/** Download PDF as Blob (use with createObjectURL) */
export const downloadReportCardPdf = async (id) => {
  const res = await axiosInstance.get(`/report-cards/cards/${id}/pdf`, {
    responseType: "blob",
  });
  return res.data;
};
